import {
  Component,
  forwardRef,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

const noop = () => {};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => spro_cls_checkbox),
  multi: true
};

@Component({
  selector: "spro-checkbox",
  template: `
    <input
      type="checkbox"
      [(ngModel)]="value"
      [class]="w_class"
      [disabled]="!f_actif"
      [id]="w_id"
    />
    <label class="k-checkbox-label" [for]="w_id">
      {{ w_label | translate }}
    </label>
  `,
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class spro_cls_checkbox implements ControlValueAccessor {
  /** Valeur d'initialisation puis sur modif */
  @Input() f_valeur: boolean = false;
  /** libellé */
  @Input() w_label: string;
  /** Identifiant */
  @Input() w_id: string = "checkbox";
  /** Pour désactiver la checkbox */
  @Input() f_actif: boolean = true;
  /** Label contenant la classe utilisé pour le style de la zone */
  @Input() w_class: string = "k-checkbox";

  @Output() e_change: EventEmitter<any> = new EventEmitter();

  /*##############################################################################
    ###################   Necessaire a la gestion du ng Model ####################
    ##############################################################################*/

  //Placeholders for the callbacks which are later providesd
  //by the Control Value Accessor
  public onTouchedCallback: () => void = noop;
  public onChangeCallback: (_: any) => void = noop;

  //get accessor
  get value(): any {
    return this.f_valeur;
  }

  //set accessor including call the onchange callback
  set value(value: any) {
    this.f_valeur = value;
    this.e_change.emit(this.f_valeur);
  }

  //Set touched on blur
  onBlur() {
    this.onTouchedCallback();
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.f_valeur) {
      this.f_valeur = value;
      this.e_change.emit(this.f_valeur);
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/inputs/spro-checkbox/spro-checkbox.component.ts